import apiClient from '../apiClient';
import { GET_ACCOMODATION_TYPES_URL } from '../apiUrl';

const getAccomodationTypesApi = () => {
  return apiClient.get(GET_ACCOMODATION_TYPES_URL);
};

export default getAccomodationTypesApi;
